import route_path from '../config/routingPath';

export default {
    install(app) {
      app.config.globalProperties.$routePath = route_path;
    }
}